<template>
    <div class="scan-ticket-detail__list-table">
        <div class="table">
            <span class="table__title">{{ getTranslatedText('ticket') }} </span>
            <div id="lottoIframe"></div>
        </div>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';
import utilsMixin from '@/mixins/function-utils';
import { parseProxyObject } from '@/utils/utils';

export default {
    mixins: [languageMixins, utilsMixin],
    props: {
        dataSource: {
            type: Object,
        },
        ticketType: {
            type: String,
        },
    },
    data() {
        return {
            iframe: null,
        };
    },
    created() {
        const configSetup = parseProxyObject(this.dataSource);
        if (!this.isObjEmpty(configSetup)) {
            if (this.ticketType == 'N') {
                this.renderIframeNumber(configSetup);
            } else if (this.ticketType == 'S') {
                this.renderIframeSport(configSetup);
            }
        }
    },

    methods: {
        renderIframeSport(configSetup) {
            const scriptJquery = document.createElement('script');
            scriptJquery.src = 'https://code.jquery.com/jquery-3.6.1.slim.min.js';
            scriptJquery.integrity = 'sha256-w8CvhFs7iHNVUtnSP0YKEg00p9Ih13rlL9zGqvLdePA=';
            scriptJquery.crossOrigin = 'anonymous';
            scriptJquery.addEventListener('load', () => {
                const scriptSport = document.createElement('script');
                scriptSport.type = 'text/javascript';
                scriptSport.src = `${configSetup.sport_url}/theme/base/js/iframe.js`;
                scriptSport.addEventListener('load', () => {
                    // eslint-disable-next-line no-undef
                    this.iframe = new iframeParent(
                        'lottoIframe',
                        `${configSetup.sport_url}/accounts/transactions`,
                        {
                            code: configSetup.sport_code,
                        },
                        {
                            token: configSetup.sport_token,
                        },
                    );
                    this.iframe.init();

                    this.iframe.requestHistory({
                        code: configSetup.sport_code,
                        page: 1,
                        dateFrom: '',
                        dateTo: '',
                        betId: configSetup.sport_bet_id,
                        gameStatus: '',
                        locale: '',
                        token: configSetup.sport_token,
                    });
                });
                document.head.appendChild(scriptSport);
            });

            document.head.appendChild(scriptJquery);
        },

        renderIframeNumber(configSetup) {
            const scriptJquery = document.createElement('script');
            scriptJquery.src = 'https://code.jquery.com/jquery-3.6.1.slim.min.js';
            scriptJquery.integrity = 'sha256-w8CvhFs7iHNVUtnSP0YKEg00p9Ih13rlL9zGqvLdePA=';
            scriptJquery.crossOrigin = 'anonymous';
            scriptJquery.addEventListener('load', () => {
                const scriptNumber = document.createElement('script');
                scriptNumber.type = 'text/javascript';
                scriptNumber.src = `${configSetup.number_gaming_url}/components/LotteryProductComponents.min.js`;
                scriptNumber.addEventListener('load', () => {
                    // eslint-disable-next-line no-undef
                    this.iframe = new LotteryProductComponentHandler();
                    this.iframe.setParam('server', configSetup.number_gaming_url);
                    this.iframe.setParam('server', configSetup.number_gaming_url);
                    this.iframe.setParam('account', configSetup.number_account);
                    this.iframe.setParam('customer', configSetup.number_token);

                    const playblockModule = {
                        name: 'betradar/details',
                        scrolling: 'no',
                        element: '#lottoIframe',
                        module: 'breakdown',
                        reference: configSetup.number_breakdown_reference,
                        currencySymbol: 'LSL',
                        locale: 'en',
                    };

                    this.iframe.createComponent(playblockModule);
                });
                document.head.appendChild(scriptNumber);
            });

            document.head.appendChild(scriptJquery);
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/scan/scanDetail.scss';
</style>
